import React from "react";
import ajax from "./../lib/ajax.js";
import RequestList from "./prf/request-list.jsx";
import context from "./../lib/context.js";
import { FormControl, ControlLabel, Button } from "react-bootstrap";
import { browserHistory } from "react-router";
import CodeList from "./shared/codelist.jsx";

export default class PRFMain extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            requestList: {
                requests: [],
                total: 0,
                totalRequested: 0,
                totalReviewed: 0,
                totalHRApproved: 0,
                pageSize: 10,
                page: 0
            },
            search: {
                startRowIndex: 0,
                maximumRows: 10,
                sortExpression: 'R.CreationDate',
                status: 'default',
            },
            isHrApprover: false,
            showMore: true,
            statuses: [],
            resources: {}
        }

        this.role = context.getRouteParam(this, "role");
        this.loadViewModel = this.loadViewModel.bind(this);
        this.loadViewModelFinal = this.loadViewModelFinal.bind(this);
        this.loadStatuses = this.loadStatuses.bind(this);
        this.setStatuses = this.setStatuses.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.onSort = this.onSort.bind(this);
        this.onStatusChange = this.onStatusChange.bind(this);
        this.onNewRequestClick = this.onNewRequestClick.bind(this);
        this.getMainIcons = this.getMainIcons.bind(this);
        this.getOtherIcons = this.getOtherIcons.bind(this);
        this.getStatusIcon = this.getStatusIcon.bind(this);
        this.loadResources = this.loadResources.bind(this);
    }

    componentDidMount() {
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        this.loadViewModel(this.state.search.startRowIndex, this.state.search.maximumRows, this.state.search.sortExpression, this.state.search.status, true);
        this.loadStatuses();
        this.loadResources();        
    }

    loadResources() {
        const self = this;

        ajax.vm()
            .get(`prf-main-resources`)
            .then(function (res) {
                self.setState({ resources: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1) {
                    browserHistory.push(context.routeUrl(`home`));
                }
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    loadStatuses() {
        let self = this;
        ajax.api().get(`get-codelist-by-category2/PRF_STATUS`)
            .then(function (res) {
                self.setStatuses(res.data);
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    setStatuses(statuses) {
        for (var i = 0; i < statuses.length; i++) {
            switch (statuses[i].code) {
                case 'SAVED':
                    if (this.role == 'supervisor') {
                        statuses[i].icon = 
                            <span className="ap-prf-status-icon">
                                <span className="gray">I</span>
                                <span className="gray">I</span>
                                <span className="gray">I</span>   
                            </span>;
                    }
                    else {
                        statuses[i].icon = <span className="ap-prf-status-icon"></span>;
                    }
                    break;
                case 'REQUESTED':
                    if (this.role == 'supervisor') {
                        statuses[i].icon = 
                            <span className="ap-prf-status-icon">
                                <span className="green">I</span>
                                <span className="gray">I</span>
                                <span className="gray">I</span>   
                            </span>;
                    }
                    else if (this.role == 'hr') {
                        statuses[i].icon = 
                            <span className="ap-prf-status-icon">
                                <span className="green">I</span>
                                <span className="gray">I</span>
                            </span>;
                    }
                    
                    break;
                case 'RETURNED_MANAGER':
                    if (this.role == 'supervisor') {
                        statuses[i].icon = 
                            <span className="ap-prf-status-icon">
                                <span className="red">I</span>
                                <span className="red">I</span>
                                <span className="red">I</span>   
                            </span>;
                    }
                    break;
                case 'APPROVED_EXEC':
                    if (this.role == 'supervisor') {
                        statuses[i].icon = 
                            <span className="ap-prf-status-icon">
                                <span className="green">I</span>
                                <span className="green">I</span>
                                <span className="gray">I</span>   
                            </span>;
                    }
                    
                    break;
                case 'SOURCING_COMPLETE': 
                    if (this.role == 'supervisor') {
                        statuses[i].icon = 
                            <span className="ap-prf-status-icon">
                                <span className="green">I</span>
                                <span className="green">I</span>
                                <span className="green">I</span>   
                            </span>;
                    }
                    else if (this.role == 'hr') {
                        statuses[i].icon = 
                            <span className="ap-prf-status-icon">
                                <span className="green">I</span>
                                <span className="green">I</span>
                            </span>;
                    }   
                    break;
                case 'APPROVED_HR':
                    if (this.role == 'exec') {
                        statuses[i].icon = 
                            <span className="ap-prf-status-icon">
                                <span className="green">I</span>
                            </span>;
                    }
                    break;
                case 'PLACED':
                    statuses[i].icon = <span className="ap-prf-status-icon"><i className="glyphicon glyphicon-ok green"></i></span>;
                    break;
                case 'REJECTED':
                    statuses[i].icon = <span className="ap-prf-status-icon"><i className="glyphicon glyphicon-remove red"></i></span>;
                    break;
            }

            if (statuses[i].icon === undefined) {
                statuses[i].icon = <span className="ap-prf-status-icon"></span>;
            }
        }

        this.setState({
            statuses: statuses
        });
    }

    loadViewModel(startRowIndex, maximumRows, sortExpression, status, initialLoad) {
        if (initialLoad === undefined)
            initialLoad = false;

        if (initialLoad == true && this.role == 'hr') {
            const self = this;

            ajax.vm()
                .get(`hr-approver`)
                .then(function (res) {
                    self.setState({
                        isHrApprover: res.data
                    });

                    self.loadViewModelFinal(startRowIndex, maximumRows, sortExpression, status, res.data);
                })
                .catch(function (err) {
                    let data = err.response.data;
                    if (data.message.toLowerCase().indexOf("unauthorize") > -1)
                        window.location = context.root() + `/../AccessDenied.aspx`;
                    else
                        context.message({
                            show: true,
                            type: "error",
                            message: data.exceptionMessage || data.message,
                            buttons: "close"
                        });
                });
        }
        else {
            this.loadViewModelFinal(startRowIndex, maximumRows, sortExpression, status);
        }
    }

    loadViewModelFinal(startRowIndex, maximumRows, sortExpression, status) {
        const self = this;

        if (sortExpression == '')
            sortExpression = 'default';

        ajax.vm()
            .get(`get-requests-by-role/${startRowIndex}/${maximumRows}/${sortExpression}/${this.role}/${status}`)
            .then(function (res) {
                let data = res.data;
                let requestList = self.state.requestList;
                requestList.requests = data.requests;
                requestList.total = data.total;
                requestList.totalRequested = data.totalRequested;
                requestList.totalReviewed = data.totalReviewed;
                requestList.totalHRApproved = data.totalHRApproved;

                self.setState({
                    requestList: requestList
                });
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.message.toLowerCase().indexOf("unauthorize") > -1)
                    window.location = context.root() + `/../AccessDenied.aspx`;
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    onNavigate(page) {
        var search = this.state.search;
        search.startRowIndex = page * search.maximumRows;

        var requestList = this.state.requestList;
        requestList.page = page;
        
        this.setState({
            search: search,
            requestList: requestList
        });

        this.loadViewModel(search.startRowIndex, search.maximumRows, search.sortExpression, search.status);
    }

    onSort(sortExpression) {
        var search = this.state.search;
        search.startRowIndex = 0;
        search.sortExpression = sortExpression;

        this.setState({
            search: search
        });

        this.loadViewModel(search.startRowIndex, search.maximumRows, search.sortExpression, search.status);
    }

    onStatusChange(value) {
        if (value == '')
            value = 'All';

        var search = this.state.search;
        search.status = value;
        search.startRowIndex = 0;

        var requestList = this.state.requestList;
        requestList.page = 0;
        
        this.setState({
            search: search,
            requestList: requestList
        });

        this.loadViewModel(search.startRowIndex, search.maximumRows, search.sortExpression, search.status);
    }

    onNewRequestClick(event) {
        browserHistory.push(context.routeUrl(`${this.role}/request-entry/0`));
    }

    getStatusIcon(code) {
        var status = this.state.statuses.filter(x => x.code == code);

        if (status.length > 0) {
            return  <div className="col-md-2">
                        <div className="ap-prf-status">
                            <div>
                                {status[0].icon}
                                <span className="ap-prf-status-label">
                                    {status[0].codeName}
                                </span>
                            </div>
                            <div>
                                <span className="ap-prf-status-sub-label">
                                    {status[0].codeDescription}
                                </span>
                            </div>
                        </div>
                    </div>;
        }
        else {
            return null;
        }
    }

    getMainIcons() {
        var icons = [];
        if (this.role == 'supervisor') {
            var icon = this.getStatusIcon('REQUESTED');
            if (icon != null) icons.push(icon);

            var icon = this.getStatusIcon('APPROVED_EXEC');
            if (icon != null) icons.push(icon);

            var icon = this.getStatusIcon('SOURCING_COMPLETE');
            if (icon != null) icons.push(icon);

            var icon = this.getStatusIcon('RETURNED_MANAGER');
            if (icon != null) icons.push(icon);

            var icon = this.getStatusIcon('SAVED');
            if (icon != null) icons.push(icon);
        }
        else if (this.role == 'hr') {
            var icon = this.getStatusIcon('REQUESTED');
            if (icon != null) icons.push(icon);

            var icon = this.getStatusIcon('SOURCING_COMPLETE');
            if (icon != null) icons.push(icon);
        }
        else if (this.role == 'exec') {
            var icon = this.getStatusIcon('APPROVED_HR');
            if (icon != null) icons.push(icon);
        }

        return <div className="row">{icons}</div>;
    }
    
    getOtherIcons() {
        var rows = [];
        var icons = [];
        var statuses = [];


        if (this.role == 'supervisor') {
            statuses = this.state.statuses.filter(x => (x.code == 'REQUESTED' || x.code == 'APPROVED_EXEC' || x.code == 'SOURCING_COMPLETE' || x.code == 'RETURNED_MANAGER' || x.code == 'SAVED') == false);
        }
        else if (this.role == 'hr') {
            statuses = this.state.statuses.filter(x => (x.code == 'REQUESTED' || x.code == 'SOURCING_COMPLETE') == false);
        }
        else if (this.role == 'exec') {
            statuses = this.state.statuses.filter(x => x.code != 'APPROVED_HR');
        }

        statuses = statuses.sort(function(obj1, obj2) { 
            if (obj1.sortOrder < obj2.sortOrder) return -1;
            if (obj1.sortOrder > obj2.sortOrder) return 1;
            return 0;
        })

        for (var i = 0; i < statuses.length; i++) {
            var icon = this.getStatusIcon(statuses[i].code);
            if (icon != null) icons.push(icon);
        }

        var rowIcons = [];
        for (var i = 0; i < (icons.length > 6 ? 6 : icons.length); i++) {
            rowIcons.push(icons[i]);
        }
        rows.push(<div className="row">{rowIcons}</div>);

        var rowIcons2 = [];
        if (icons.length > 6) {
            for (var i = 6; i < icons.length; i++) {
                rowIcons2.push(icons[i]);
            }
            rows.push(<div className="row" style={{"paddingTop" : "10px"}}>{rowIcons2}</div>);
        }

        return rows;
    }

    render() {
        var left = ''
        if (this.role == 'supervisor') {
            left = <Button id="new-request" className="btn-info" onClick={this.onNewRequestClick}><span className="fa fa-plus-circle ap-green-color"></span><span style={{ "marginLeft" : "5px" }}>{this.state.resources.newRequest}</span></Button>
        }
        else if (this.role == 'hr' && this.state.isHrApprover == true) {
            left = 
                <div className="ap-timecard-list-legend">
                    <div>
                        <span className="fa fa-exclamation-circle ap-blue-color"/> 
                        <span className="ap-5-margin-left"><ControlLabel>{this.state.requestList.totalReviewed + ' ' + this.state.resources.newRequestsForApproval}</ControlLabel></span>
                    </div>
                </div>
        }
        else if (this.role == 'hr') {
            left = 
                <div className="ap-timecard-list-legend">
                    <span className="fa fa-exclamation-circle ap-blue-color"/>
                    <span className="ap-5-margin-left"><ControlLabel>{this.state.requestList.totalRequested + ' ' + this.state.resources.newRequests}</ControlLabel></span>
                </div>
        }
        else if (this.role == 'exec') {
            left = 
                <div className="ap-timecard-list-legend">
                    <span className="fa fa-exclamation-circle ap-blue-color"/>
                    <span className="ap-5-margin-left"><ControlLabel>{this.state.requestList.totalHRApproved + ' ' + this.state.resources.newRequestsForApproval}</ControlLabel></span>
                </div>
        }

        return (
            <div className="container" style={{ "width" : "100%", "paddingRight" : "20px", "paddingLeft" : "20px" }}>
                <div className="row hidden-sm hidden-xs">
                    <div className="col-md-12">
                        <h2 className="text-center ap-title">{this.state.resources.positionRequisition}</h2>
                    </div>
                </div>
                <div className={"row hidden-sm hidden-xs " + (this.role != 'supervisor' ? 'ap-hidden' : '' )}>
                    <div className="col-md-12">
                        <h2 className="text-center ap-sub-title">
                            {this.state.resources.positionRequisitionSubTitle}
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        {left}
                    </div>
                    <div className="col-md-3">
                        <ControlLabel className="ap-report-control-label pull-right">{this.state.resources.statusFilter}:</ControlLabel>
                    </div>
                    <div className="col-md-3 pull-right">
                        <CodeList 
                            id="filter" 
                            value={this.state.search.status} 
                            onChange={this.onStatusChange} 
                            category="PRF_STATUS"
                            allText="All"
                            readOnly={false}
                            hasDefault={true} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <RequestList vm={this.state.requestList} role={this.role} onNavigate={this.onNavigate} onSort={this.onSort} search={this.state.search} statuses={this.state.statuses} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <span><ControlLabel>{this.state.resources.statusDefinitions}</ControlLabel></span>
                        <span className="ap-prf-status-definition-show-link"><a href="javascript:void(0)" onClick={() => { this.setState({
                            showMore: !this.state.showMore
                        }) }}><ControlLabel>{this.state.showMore == true ? this.state.resources.showMore : this.state.resources.showLess}</ControlLabel></a></span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-10">
                        <div className="ap-prf-status-container">
                            <div>
                                {this.getMainIcons()}
                            </div>
                            <div className={'ap-prf-status-other-container ' + (this.state.showMore == true ? 'ap-hidden' : '')}>
                                {this.getOtherIcons()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}